import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { StoreService } from '../../store.service';
import { UtilitiesService } from 'src/app/core/utilities.service';

@Component({
  selector: 'app-visitor-intelligence',
  templateUrl: './visitor-intelligence.component.html',
  styleUrls: ['./visitor-intelligence.component.scss'],
})
export class VisitorIntelligenceComponent implements OnInit {
  bearer: string = '';
  storeId: string = '';
  sessionReplayEnabled: boolean = true;
  isSessionReplayLoading: boolean = false;
  isInitialLoading: boolean = true;

  constructor(
    private router: Router,
    private svc: StoreService,
    public utils: UtilitiesService
  ) {}

  ngOnInit(): void {
    this.bearer = localStorage.getItem('bearer') || '';
    this.storeId = localStorage.getItem('store_id') || '';
    this.loadSessionReplaySetting();
  }

  loadSessionReplaySetting(): void {
    const storeId = this.storeId || localStorage.getItem('store_id');
    if (!storeId) {
      this.sessionReplayEnabled = true;
      this.isInitialLoading = false;
      return;
    }

    this.isInitialLoading = true;
    this.svc.getStoreConfig(this.bearer, storeId, 'session_replay').subscribe(
      (res: any) => {
        this.isInitialLoading = false;
        const data = res?.data;
        if (!data || data?.error === null) {
          this.sessionReplayEnabled = true;
          return;
        }
        const rawVal =
          data?.value !== undefined
            ? data.value
            : data?.session_replay !== undefined
            ? data.session_replay
            : data;
        if (rawVal === undefined || rawVal === null) {
          this.sessionReplayEnabled = true;
          return;
        }
        const strVal = String(rawVal).trim().toLowerCase();
        this.sessionReplayEnabled =
          strVal !== 'false' && strVal !== '0' && strVal !== 'disabled' && strVal !== 'off';
      },
      () => {
        this.isInitialLoading = false;
        this.sessionReplayEnabled = true;
      }
    );
  }

  toggleSessionReplay(event: any): void {
    const nextVal = event.target.checked;
    this.sessionReplayEnabled = nextVal;
    this.isSessionReplayLoading = true;

    const storeId = this.storeId || localStorage.getItem('store_id');
    const body = {
      name: 'session_replay',
      store_id: storeId,
      value: this.sessionReplayEnabled ? 'true' : 'false',
    };

    this.svc.updateConfig(this.bearer, body).subscribe(
      () => {
        this.isSessionReplayLoading = false;
        this.utils.notify.showSuccess(
          this.utils.translate('Session Replay Settings Updated Successfully!')
        );
      },
      (error) => {
        this.isSessionReplayLoading = false;
        event.target.checked = !nextVal;
        this.sessionReplayEnabled = !nextVal;
        this.utils.notify.showError(
          this.utils.translate('Failed to Update Session Replay Settings')
        );
      }
    );
  }

  enableSessionReplay(): void {
    if (this.sessionReplayEnabled || this.isSessionReplayLoading) return;
    this.isSessionReplayLoading = true;
    const storeId = this.storeId || localStorage.getItem('store_id');
    const body = {
      name: 'session_replay',
      store_id: storeId,
      value: 'true',
    };

    this.svc.updateConfig(this.bearer, body).subscribe(
      () => {
        this.sessionReplayEnabled = true;
        this.isSessionReplayLoading = false;
        this.utils.notify.showSuccess(
          this.utils.translate('Session Replay Settings Updated Successfully!')
        );
      },
      () => {
        this.isSessionReplayLoading = false;
        this.utils.notify.showError(
          this.utils.translate('Failed to Update Session Replay Settings')
        );
      }
    );
  }

  goToSessionReplay(): void {
    this.router.navigate(['/dashboard/replay']);
  }

  goToHeatmap(): void {
    this.router.navigate(['/dashboard/replay/heatmap']);
  }
}
